import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData() {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();

  let searchQueryEmployeeData = new URLSearchParams({
    ...searchOptions,
    status: 0,
  }).toString();

  // Fetch constant data concurrently
  const [
    project,
    employee,
    bookingEvent,
    customer,
    employeeData,
    customerType,
    saleArea,
    saleBlock,
    apartment,
    branch,
    supportDepartment,
  ] = await Promise.all([
    clientAPI("get", `/project?${searchQueryParams}`),
    clientAPI("get", `/employee?${searchQueryParams}`),
    clientAPI("get", `/bookingEvent?${searchQueryParams}`),
    clientAPI("get", `/customer?${searchQueryParams}`),
    clientAPI("get", `/employee?${searchQueryEmployeeData}`),
    clientAPI("get", `/customerType?${searchQueryParams}`),
    clientAPI("get", `/saleArea?${searchQueryParams}`),
    clientAPI("get", `/saleBlock?${searchQueryParams}`),
    clientAPI("get", `/apartment?${searchQueryParams}`),
    clientAPI("get", `/branch?${searchQueryParams}`),
    clientAPI("get", `/supportDepartment?${searchQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    project: project?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    employee: employee?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
    bookingEvent: bookingEvent?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    customer: customer?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          fullName: item.name,
          code: item.code,
          phone: item.phone,
          identificationNumber: item.identificationNumber,
        },
      }),
      {}
    ),
    employeeData: employeeData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
    customerType: customerType?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleArea: saleArea?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleBlock: saleBlock?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    apartment: apartment?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    branch: branch?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    supportDepartment: supportDepartment?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
  };
}

export function useCategories(shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories6"],
    queryFn: () => fetchConstantData(),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
